import { render, staticRenderFns } from "./Actiday.vue?vue&type=template&id=210b0f68&scoped=true"
import script from "./Actiday.vue?vue&type=script&lang=js"
export * from "./Actiday.vue?vue&type=script&lang=js"
import style0 from "./Actiday.vue?vue&type=style&index=0&id=210b0f68&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210b0f68",
  null
  
)

export default component.exports